import { useEffect, useRef, useState } from 'react'

/**
 * Petit hook d'apparition au scroll (IntersectionObserver), sans dépendance.
 * Ajoute la classe "is-visible" sur l'élément une fois qu'il entre dans le viewport.
 */
export function useReveal(options = { threshold: 0.15 }) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node) return

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true)
        observer.unobserve(node)
      }
    }, options)

    observer.observe(node)
    return () => observer.disconnect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [ref, visible]
}
